module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content--first blue clear",
    attrs: {
      "id": "hangul-blocks-slides"
    }
  }, [_c('div', {
    staticClass: "column--single spacer--small"
  }, [_c('div', {
    staticClass: "progress-dots-container"
  }, [_c('div', {
    staticClass: "cf progress-dots"
  }, _vm._l((_vm.slides), function(index, slide) {
    return _c('div', {
      staticClass: "progress-dot pointer",
      class: {
        active: _vm.slideNum === slide
      },
      on: {
        "click": function($event) {
          _vm.goToSlide(index)
        }
      }
    })
  }))]), _vm._v(" "), _c('v-touch', {
    staticClass: "column--single center img--100 relative transition-opacity",
    on: {
      "tap": function($event) {
        _vm.nextSlide()
      },
      "swipe-right": function($event) {
        _vm.nextSlide()
      },
      "swipe-left": function($event) {
        _vm.prevSlide()
      }
    }
  }, _vm._l((_vm.slides), function(slide) {
    return _c('img', {
      class: {
        hidden: _vm.slideNum !== slide, 'absolute top-left': slide !== 0
      },
      attrs: {
        "src": ("/static/images/hangul-blocks/slide-" + (slide + 1) + ".svg"),
        "alt": "Hangul Blocks"
      }
    })
  })), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/hangul-blocks/slide-translation.svg",
      "alt": "na noon han gook een ee a neeb nee da"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "spacer--small caps center text--blue h3-responsive"
  }, [_vm._v("(I am not Korean)")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e3df0a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HangulBlocksSlides.vue
// module id = 136
// module chunks = 0